import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  initialFormData,
  MasterFormDataType,
  MasterTableDataType,
} from "./types";
import usePopup from "../../../hooks/usePopup";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import { getAllEmployee, getAllMinistry, saveMasterData } from "./services";
import {
  Paper,
  Typography,
  Button,
  CircularProgress,
  Divider,
} from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import useAuthentication from "../../../hooks/useAuthentication";
const pageTitle = "Clinician";
function AddOrEditClinician() {
  const { user } = useAuthentication();
  const navigate = useNavigate();
  const { control, handleSubmit, reset } =
    useForm<MasterFormDataType>({
      defaultValues: initialFormData,
    });
  const {
    state: { data = null },
  } = useLocation() as { state: { data: MasterTableDataType } };
  const { showSnackbar } = usePopup();
  const handleGoBack = () => {
    navigate(-1);
  };

  const { data: employees } = useQuery(
    ["getAllEmployee"],
    () => getAllEmployee(""),
    { refetchOnWindowFocus: false }
  );
  const { data: misinstryList } = useQuery(["getAllMinistry"], getAllMinistry, {
    refetchOnWindowFocus: false,
  });

  const { mutate: save, isLoading } = useMutation(saveMasterData, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        handleGoBack();
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message: e?.response?.data?.responseMessage || "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });

  const onSubmit = (value: MasterFormDataType) => {
    save([
      {
        clinicId: user?.clinicId as number,
        clinicianCode: value?.clinicanCode,
        clinicianName: value?.ClincianName?.empName as string,
        clinicianId: data?.clinicianId || 0,
        clinicianStatus: Number(value?.clinicianStatus) as number,
        clinicMinistry: value?.ministry?.ministryName as string,
        createdByUserId: Number(user?.userId),
      },
    ]);
  };

  const handleReset = () => {
    reset({
      ClincianName: null,
      ministry: null,
      clinicianStatus: 1,
    });
  };

  useEffect(() => {
    if (data && Boolean(misinstryList?.response)) {
      const ministry = misinstryList?.response?.find(
        (item: { id: number; ministryName: string }) =>
          item?.ministryName === data?.clinicianMinistry
      );
      reset({
        clinicanCode: data?.clinicianCode || "",
        ClincianName: {
          empId: data?.clinicianId,
          empName: data?.clinicianName,
        },
        ministry: ministry,
        clinicianStatus: data?.clinicianStatus,
      });
    }
  }, [data, misinstryList]);
  return (
    <div className="p-3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                {data ? "Update" : "Add"} {pageTitle}
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                disabled={isLoading}
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
              >
                back
              </Button>
              {!Boolean(data) && (
                <Button
                  disabled={isLoading}
                  color="error"
                  type="reset"
                  onClick={handleReset}
                  startIcon={<CloseIcon />}
                >
                  reset
                </Button>
              )}
              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <SaveIcon />
                  )
                }
              >
                {data ? "update" : "save"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-4 gap-3">
            <CustomFormField
              control={control}
              name="clinicanCode"
              element="input"
              fieldProps={{ label: "Enter Clinician code " }}
              rules={{ required: "clinician code is required" }}
            />
            <CustomFormField
              control={control}
              name="ClincianName"
              element="autocomplete"
              options={employees?.response ?? []}
              fieldProps={{ label: "Enter Clincian Name " }}
              rules={{ required: "Clincian Name is required" }}
              autocompleteProps={{
                getOptionLabel: (option) => option.empName || "",
                isOptionEqualToValue: (option, value) =>
                  option.empId === value.empId,
              }}
            />

            <div>
              <CustomFormField
                control={control}
                name="ministry"
                element="autocomplete"
                fieldProps={{ label: "select Ministry" }}
                rules={{ required: "ministry  is required" }}
                options={misinstryList?.response ?? []}
                autocompleteProps={{
                  getOptionLabel: (option) => option.ministryName || "",
                  isOptionEqualToValue: (option, value) =>
                    option.id === value.id,
                }}
              />
            </div>
            <CustomFormField
              control={control}
              name="clinicianStatus"
              element="radio"
              radioProps={{ row: true }}
              radios={[
                { label: "Active", value: 1 },
                { label: "Inactive", value: 0 },
              ]}
              fieldProps={{ label: "Status " }}
              rules={{ required: "ICD version is required" }}
            />
          </div>
        </Paper>
      </form>
    </div>
  );
}

export default AddOrEditClinician;
